import { render } from "./add-custom.vue?vue&type=template&id=4b0a01e4&lang=pug"
import script from "./add-custom.vue?vue&type=script&lang=js"
export * from "./add-custom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__